import type { PropsWithChildren } from 'react'
import { Heading, type HeadingProps } from '../../../heading/heading.tsx'
import { Text } from '../../../text/text.tsx'
import { useCardContext } from '../../use-card.ts'
export type CardHeadingTitleProps = PropsWithChildren<
  Pick<HeadingProps, 'className' | 'dataTestId' | 'dataTrackingId' | 'fontSize'>
>

const CardHeadingTitle = ({
  children,
  className,
  fontSize,
  ...testIds
}: CardHeadingTitleProps) => {
  const { scale } = useCardContext()

  if (scale === 'sm') {
    return (
      <Text fontSize="base" className={className} {...testIds}>
        {children}
      </Text>
    )
  }

  return (
    <Heading
      fontSize={fontSize ?? (scale === 'lg' ? '3xl' : 'xl')}
      {...testIds}
      className={className}
    >
      {children}
    </Heading>
  )
}

export { CardHeadingTitle }
